import { render, staticRenderFns } from "./sentenceM2.vue?vue&type=template&id=20191465&scoped=true&"
import script from "./sentenceM2.vue?vue&type=script&lang=js&"
export * from "./sentenceM2.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM2.vue?vue&type=style&index=0&id=20191465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20191465",
  null
  
)

export default component.exports